import { diagram } from '@diagram/state/diagram';
import { Helpers, SideEffect } from '@diagram/state/effects/diagram/helpers';

import { SyncEngineHelpers } from 'helpers/SyncEngineHelpers';

const cleanupFaultFeedingPortsOnDelete: SideEffect = (change) => {
    const { type, data } = change;

    if (type !== 'delete') return;

    const paths = (Array.isArray(data) ? data : Object.keys(data)) as string[];

    for (const path of paths) {
        const match = Helpers.matchComponentInstance<{
            port: string;
        }>(path, /specifications\.electrical\.ports\.(?<port>\d+)$/);

        if (!match) {
            continue;
        }

        const { id, port } = match;
        const deletedPortIndex = Number.parseInt(port, 10);
        const componentInstance = diagram.componentInstances[id];

        if (!componentInstance) {
            continue;
        }

        componentInstance.specifications.electrical.ports.forEach((portSpecifications, index) => {
            if ('faultFeedingPorts' in portSpecifications && Array.isArray(portSpecifications.faultFeedingPorts)) {
                const updatedFaultFeedingPorts = portSpecifications.faultFeedingPorts.filter(
                    (feedingPort: number) => feedingPort !== deletedPortIndex,
                );

                SyncEngineHelpers.set(
                    componentInstance,
                    `specifications.electrical.ports.${index}.faultFeedingPorts`,
                    updatedFaultFeedingPorts,
                );
            }
        });
    }
};

export { cleanupFaultFeedingPortsOnDelete };
